'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const delay=require('pulsar-utils/dist-es6/async/delay');
const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const WaypointTypes=require('../../../../../dist-es6/client/domain/waypointTypes');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');let

ScenarioSetupModalController=(_dec=






























HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseController){_inherits(ScenarioSetupModalController,_BaseController);_createClass(ScenarioSetupModalController,null,[{key:'$inject',get:function(){return['$modalInstance','dateService','uiCommandFactory','personId','tripPlanningService','originAddress','uncaughtErrorHandler']}}]);function ScenarioSetupModalController($modalInstance,dateService,uiCommandFactory,personId,tripPlanningService,originAddress,uncaughtErrorHandler){_classCallCheck(this,ScenarioSetupModalController);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._$modalInstance=$modalInstance;_this._tripPlanningService=tripPlanningService;_this._personId=personId;let currentTime=dateService.now();_this._originAddress=originAddress;_this._originTime=currentTime;_this._originTime.setSeconds(0);_this._originTime.setMilliseconds(0);_this._originWaypointType=WaypointTypes.unselected;_this._destinationAddress=null;_this._destinationTime=null;_this._destinationWaypointType=WaypointTypes.unselected;_this._submissionErrors=[];_this._calculateRouteCommand=uiCommandFactory.makeForModal($modalInstance,_this._calculate.bind(_this));return _this}ScenarioSetupModalController.prototype.
_calculate=function(){var ref=_asyncToGenerator(function*(){
let planInputs=[{
address:this.originAddress,
displayTime:this.originTime,
waypointType:this.originWaypointType},
{
address:this.destinationAddress,
displayTime:this.destinationTime,
waypointType:this.destinationWaypointType}];

let result=yield this._tripPlanningService.plan(this._personId,planInputs);

if(_.exists(result.errors)){
this._submissionErrors=result.errors;
return ModalSubmissionResult.KeepOpen;
}


result.originalInputs=planInputs;
return ModalSubmissionResult.Close(result);
});function _calculate(){return ref.apply(this,arguments)}return _calculate}();ScenarioSetupModalController.prototype.

onCancel=function onCancel(){
this._$modalInstance.dismiss();
};_createClass(ScenarioSetupModalController,[{key:'calculateRouteCommand',get:function(){return this._calculateRouteCommand}},{key:'submissionErrors',get:function()

{
return this._submissionErrors;
}},{key:'waypointTypes',get:function()

{
return WaypointTypes.all;
}},{key:'destinationAddress',get:function()

{
return this._destinationAddress;
},set:function(

newDestinationAddress){
this._destinationAddress=newDestinationAddress;
}},{key:'destinationTime',get:function()

{
return this._destinationTime;
},set:function(

newDestinationTime){
this._destinationTime=newDestinationTime;
}},{key:'destinationWaypointType',get:function()

{
return this._destinationWaypointType;
},set:function(

newDestinationWaypointType){
this._destinationWaypointType=newDestinationWaypointType;
}},{key:'originAddress',get:function()

{
return this._originAddress;
},set:function(

newOriginAddress){
this._originAddress=newOriginAddress;
}},{key:'originTime',get:function()

{
return this._originTime;
},set:function(

newOriginTime){
this._originTime=newOriginTime;
}},{key:'originWaypointType',get:function()

{
return this._originWaypointType;
},set:function(

newOriginWaypointType){
this._originWaypointType=newOriginWaypointType;
}}]);return ScenarioSetupModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_calculate',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_calculate'),_class.prototype)),_class));


module.exports=ScenarioSetupModalController;
//# sourceMappingURL=scenarioSetupModalController.js.map
